export default "__VITE_ASSET__3NpMYE4b__"